import moduleIntegrityCheck from "~components/shared/module/Module.integrity";
import type { VariationComponent } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck(
    props: VariationComponent
): IntegrityStatus {
    const messages = moduleIntegrityCheck(props);

    if (!props.title) messages.push("Missing header title");

    return messages;
}
